import { Box, Heading, Skeleton, VStack } from '@chakra-ui/react';

interface ICanvasWrapperProps {
  children: React.ReactNode;
  isLoading: boolean;
  error: boolean;
}

const CanvasWrapper = ({ children, isLoading, error }: ICanvasWrapperProps) => {
  return (
    <VStack
      alignItems="flex-start"
      bg="white"
      borderColor="gray.200"
      shadow="sm"
      borderRadius={14}
      boxShadow="6px 6px 54px 0 rgba(0, 0, 0, 0.05);"
      w="100%"
      gap={8}
      p={6}
    >
      <Box pb={2}>
        <Heading fontSize={24} fontWeight={500}>Result Canvas</Heading>
      </Box>
      {isLoading && !error && (
        <Box width="100%">
          <Skeleton minH={300} height="100%" width="100%" />
        </Box>
      )}
      {children}
    </VStack>
  );
};

export default CanvasWrapper;